import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import common from '../../common.module.scss';
import {
    getSchedulePlayers,
    removeSchedulePlayer,
    addSchedulePlayer,
    searchUsers
} from '../../api/adminApi';
import { toast } from "react-toastify";
import { FaArrowLeft } from "react-icons/fa";
import { updateUserArrive } from "../../api/ScheduleApi";
import styles from './schedule.module.css';
import { EmployeeContext } from "../../context/EmployeeContext.jsx";
import useIsMobile from "@/shared/lib/hooks/useIsMobile";
import {RiDeleteBinLine} from "react-icons/ri";
import {pluralize} from "@/shared/lib/pluralize/pluralize.js";

export default function EditPlayersPage() {
    const { employee } = useContext(EmployeeContext);
    const role = employee?.role;

    const { id } = useParams();
    const navigate = useNavigate();
    const isMobile = useIsMobile();

    const [players, setPlayers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);

    useEffect(() => {
        loadPlayers();
    }, [id]);

    const loadPlayers = async () => {
        try {
            const res = await getSchedulePlayers(id);
            setPlayers(res.data);
        } catch (e) {
            const errorMessage = e?.response?.data?.message || 'Ошибка при загрузке игроков';
            toast.error(errorMessage);
        }
    };

    const handleDelete = async (userId) => {
        try {
            await removeSchedulePlayer(id, userId);
            window.location.reload();
        } catch (e) {
            const errorMessage = e?.response?.data?.message || 'Ошибка удаления игрока';
            toast.error(errorMessage);
        }
    };

    const handleSearch = async () => {
        try {
            const res = await searchUsers(searchTerm);
            setSearchResults(res.data);
        } catch (e) {
            const errorMessage = e?.response?.data?.message || 'Ошибка при поиске пользователя';
            toast.error(errorMessage);
        }
    };

    const handleAdd = async () => {
        try {
            await addSchedulePlayer(id, { userId: selectedUserId });
            setShowModal(false);
            setSearchTerm('');
            setSelectedUserId(null);
            setSearchResults([]);
            loadPlayers();
        } catch (e) {
            const errorMessage = e?.response?.data?.message || 'Ошибка при добавлении пользователя';
            toast.error(errorMessage);
        }
    };

    const updateArrivalStatus = async (status, userId) => {
        try {
            await updateUserArrive(id, status, userId);
            setPlayers(prev =>
                prev.map(player =>
                    player.id === userId ? { ...player, isArrive: status } : player
                )
            );
        } catch (e) {
            toast.error( e?.response?.data?.message ||'Ошибка при обновлении статуса');
        }
    };

    const handleConfirm = (userId) => updateArrivalStatus(true, userId);
    const handleCancel = (userId) => updateArrivalStatus(false, userId);
    const handleChange = (userId) => updateArrivalStatus(null, userId);

    return (
        <main className={common.container + " min-vh-100 d-flex justify-content-center align-items-center"}>
            <div className={`container ${common.container}`}>
                <div className={`row mb-3 d-flex align-items-center`}>
                    <span className="btn-word black btn-link col-md-auto col-2" onClick={() => navigate(-1)}>
                        <FaArrowLeft className={common.serviceButton} />
                    </span>
                    <h2 className="col-md col-10">Редактирование мест</h2>
                    <div className="d-flex justify-content-end col">
                        {role !== "MASTER" && !isMobile && (
                            <button className="service-btn" onClick={() => setShowModal(true)}>
                                Добавить игрока
                            </button>
                        )}
                    </div>
                </div>

                <table className={`table ${common.table}`}>
                    <thead className={common.tableHeader}>
                    <tr>
                        <th>ID</th>
                        <th>Имя и фамилия</th>
                        {
                            !isMobile && (<>
                                <th>Телефон</th>
                                <th>Количество записей</th>
                                <th>Промокод</th>
                                <th>Оплатить</th>
                                <th></th>
                            </>)
                        }

                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {players.map((player, index) => (
                        isMobile ? (
                            <tr key={player.id}>
                                <td colSpan="100%">
                                    <div className={`${styles.mobilePlayerCard} ${player.isArrive === null ? '' : player.isArrive ? styles.arrived : styles.notArrived}`}>
                                        <div className={"row"}>
                                            <div className={styles.playerInfo + " col-10"}>
                                                <div><strong>ID: {player.id}</strong></div>
                                                <div>{player.fio}</div>
                                                <div>{player.phone}</div>
                                                <div style={{ color: '#6c757d' }}>{player.count} {pluralize(player.count, ['запись','записи',"записей"])  }</div>
                                            </div>
                                            <div className="d-flex justify-content-end mt-2 col-2">
                                                <button
                                                    className={"text-danger btn-word"}
                                                    onClick={() => handleDelete(player.id)}
                                                >
                                                    <RiDeleteBinLine  className={common.icon}/>
                                                </button>
                                            </div>
                                        </div>
                                        <div>
                                            Промокод: {player.usedPromo}
                                        </div>
                                        <div>
                                            Осталось заплатить: {player.remainsToPay}
                                        </div>
                                        <div className={styles.actions}>
                                            {player.isArrive === null ? (
                                                <>
                                                    <button className={styles.confirm} onClick={() => handleConfirm(player.id)}>Подтвердить</button>
                                                    <button className={styles.cancel} onClick={() => handleCancel(player.id)}>Отменить</button>
                                                </>
                                            ) : player.isArrive ? (
                                                <>
                                                    <p className="text-success text-center">Игрок пришёл!</p>
                                                    <button className={styles.cancel} onClick={() => handleChange(player.id)}>Не пришёл?</button>
                                                </>
                                            ) : (
                                                <>
                                                    <p className="text-danger text-center">Игрок не пришёл!</p>
                                                    <button className={styles.confirm} onClick={() => handleChange(player.id)}>Пришёл?</button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            <tr key={player.id} className={index % 2 !== 0 ? common.altRow : ''}>
                                <td>{player.id}</td>
                                <td>{player.fio}</td>
                                <td>{player.phone}</td>
                                <td>{player.count}</td>
                                <td>{player.usedPromo}</td>
                                <td>{player.remainsToPay}</td>
                                <td>
                                    <button
                                        className="btn-word red btn-link"
                                        onClick={() => handleDelete(player.id)}
                                    >
                                        Удалить
                                    </button>
                                </td>
                                <td>
                                    {player.isArrive === null ? (
                                        <div className="row g-0 gap-3">
                                            <button
                                                className={`${styles.btnEditPlayers} ${styles.confirm} col`}
                                                onClick={() => handleConfirm(player.id)}
                                            >
                                                Подтвердить
                                            </button>
                                            <button
                                                className={`${styles.btnEditPlayers} ${styles.cancel} col`}
                                                onClick={() => handleCancel(player.id)}
                                            >
                                                Отменить
                                            </button>
                                        </div>
                                    ) : player.isArrive ? (
                                        <div className="row g-0">
                                            <p className="body text-success col">Игрок пришёл!</p>
                                            <button
                                                className="col btn-word black btn-link"
                                                onClick={() => handleChange(player.id)}
                                            >
                                                Не пришёл?
                                            </button>
                                        </div>
                                    ) : (
                                        <div className="row g-0">
                                            <p className="body text-danger col">Игрок не пришёл!</p>
                                            <button
                                                className="col btn-word black btn-link"
                                                onClick={() => handleChange(player.id)}
                                            >
                                                Пришёл?
                                            </button>
                                        </div>
                                    )}
                                </td>
                            </tr>
                        )
                    ))}
                    </tbody>

                </table>
                <div className="w-100">
                    {role !== "MASTER" && isMobile && (
                        <button className="service-btn w-100" onClick={() => setShowModal(true)}>
                            Добавить игрока
                        </button>
                    )}
                </div>
                {showModal && (
                    <div className={common.modalOverlay}>
                        <div className={common.modal}>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Добавление игрока</h5>
                                <p className="btn-word btn-close" onClick={() => setShowModal(false)}></p>
                            </div>
                            <div className="input-group mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Поиск"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                                    autoFocus
                                />
                                <p className="btn-word btn-outline-secondary" onClick={handleSearch}>
                                    <i style={{ fontSize: 32 }} className="bi bi-search text-black ms-2"></i>
                                </p>
                            </div>
                            <ul className={common.modalList + " list-group mb-3"}>
                                {searchResults.map(user => (
                                    <li
                                        key={user.id}
                                        className={`list-group-item ${selectedUserId === user.id ? 'active' : ''}`}
                                        onClick={() => setSelectedUserId(user.id)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {user.fio} | {user.phone}
                                    </li>
                                ))}
                            </ul>
                            <button
                                className="serviceButton w-100 service-btn"
                                onClick={handleAdd}
                                disabled={!selectedUserId}
                            >
                                Сохранить
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </main>
    );
}
